import type { ZudokuConfig } from "zudoku";

const helpUrl = "https://help.atomictax.com";

const config: ZudokuConfig = {
  page: {
    pageTitle: "",
    logo: {
      src: {
        light: "/logos/logo-text.svg",
        dark: "/logos/logo-text.svg",
      },
      width: "200px",
    },
    banner: {
      message: (
        <>
          AtomicTax API is currently in beta. Please report any issues to{" "}
          <a href={helpUrl} target="_blank" rel="noopener noreferrer" className="underline font-medium">
            https://help.atomictax.com
          </a>
          .
        </>
      ),
      color: "#324398",
      dismissible: true,
    },
  },
  theme: {
    light: {
      primary: "243 52% 39%",
      primaryForeground: "243 5.2% 96.95%",
    },
    dark: {
      primary: "243 52% 39%",
      primaryForeground: "243 5.2% 96.95%",
    },
  },
  topNavigation: [
    { id: "docs", label: "Merchant guides" },
    { id: "api", label: "Merchant API" },
    { id: helpUrl, label: "Support" },
  ],
  sidebar: {
    docs: [
      {
        type: "category",
        label: "Getting started",
        items: ["introduction", "authentication", "rate-limiting"],
      },
      {
        type: "category",
        label: "Partner API data",
        items: ["customer-exemptions", "sales-transactions"],
      },
      {
        type: "category",
        label: "Sales tax",
        items: ["product-categories", "versions"],
      },
    ],
  },
  redirects: [
    { from: "/", to: "/docs" },
    { from: "/docs", to: "/docs/introduction" },
    { from: "/coming-soon", to: "/api" },
    { from: "/docs/api", to: "/api" },
  ],
  apis: [
    {
      type: "file",
      input: "./apis/public.openapi.json",
      navigationId: "api",
    },
  ],
  docs: {
    files: "/pages/**/*.{md,mdx}",
  },
  metadata: {
    title: "AtomicTax Developer Documentation",
    description:
      "Developer documentation for AtomicTax — merchant partner REST API (sales tax, transactions, nexus).",
    logo: "/logos/logo-text.svg",
    favicon: "/favicon.png",
    applicationName: "AtomicTax Developer Portal",
    referrer: "no-referrer",
    keywords: [
      "sales tax software",
      "sales tax API",
      "shopify sales tax",
    ],
  },
};

export default config;
